import React from 'react';
import PropTypes from 'prop-types';

const RetestStatusBadge = ({ status }) => {
    switch (status) {
        case 'pending':
            return <span className="px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">Assigned</span>;
        case 'used':
            return <span className="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Used</span>;
        case 'expired':
            return <span className="px-2 py-1 text-xs font-semibold rounded-full bg-gray-100 text-gray-800">Expired</span>;
        case 'eligible':
            return <span className="px-2 py-1 text-xs font-semibold rounded-full bg-amber-100 text-amber-800">Eligible</span>;
        default:
            return <span className="px-2 py-1 text-xs font-semibold rounded-full bg-gray-50 text-gray-500">None</span>;
    }
};

RetestStatusBadge.propTypes = {
    status: PropTypes.string,
};

export default RetestStatusBadge;